import { render, staticRenderFns } from "./home-team.vue?vue&type=template&id=5c387124&scoped=true&"
import script from "./home-team.vue?vue&type=script&lang=js&"
export * from "./home-team.vue?vue&type=script&lang=js&"
import style0 from "./home-team.vue?vue&type=style&index=0&id=5c387124&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c387124",
  null
  
)

export default component.exports